import {  setBoxStyle } from "../canvasUtils";
import InteractiveAnnotation from "./interactiveAnnotation";

export default class MeasurementText extends InteractiveAnnotation{
  constructor() {
    super();

    this.x = 0;
    this.y = 0;
    this.width = 0;
    this.height = 0;  
    this.isDetach = false;
    this.textContextRotation = 0;
  }

  get bottomLeft (){
    return this.y + this.height;
  }

  get cx(){
    return this.width/2;
  }

  get cy(){
    return this.height/2;
  }

  updateAndDrawRotatedText(width, height, ctx, text, x, y, textContextRotation){
    this.updateTextWidthHeight(width, height);
    this.drawRotatedMeasurementText(ctx, text, x, y, textContextRotation)
  }

  drawRotatedMeasurementText(ctx, text, x, y, textContextRotation){
    if(!this.isDetach){      
      ctx.save();
      ctx.translate(x, y)
      ctx.rotate(textContextRotation);
      ctx.fillText(text, 0, 0);
      ctx.restore();
      this.updatePosition(x, y);
      this.textContextRotation = textContextRotation;
    }else{
      ctx.save();
      ctx.translate(this.x, this.y)
      ctx.rotate(this.textContextRotation);
      ctx.fillText(text, 0, 0);
      ctx.restore();
    }
  }

  updateAndDraw(width, height, ctx, text, x, y){
    this.updateTextWidthHeight(width, height);
    this.drawMeasurementText(ctx, text, x, y)
  }

  updateTextWidthHeight(width, height){
    this.width = width;
    this.height = height;
  }

  updatePosition(x, y){
    this.x = x;
    this.y = y;
  }

  drawMeasurementText(ctx, text, x, y){
    if(!this.isDetach){
      ctx.fillText(text, x, y);
      this.updatePosition(x, y);
    }else{
      ctx.fillText(text, this.x, this.y);
    }
  }

  drawTextInteractionBoxe(ctx){
    setBoxStyle(ctx);
    ctx.beginPath();
    ctx.strokeRect(this.x , this.y,  this.width, this.height);
    ctx.closePath();
  }

  drawRotatedTextInteractionBox(ctx){
    setBoxStyle(ctx);
    let corners = this.getRotatedCorners();
    ctx.beginPath();
    ctx.moveTo(corners.topLeft.x, corners.topLeft.y);
    ctx.lineTo(corners.bottomLeft.x, corners.bottomLeft.y);
    ctx.lineTo(corners.bottomRight.x, corners.bottomRight.y);
    ctx.lineTo(corners.topRight.x, corners.topRight.y);
    ctx.lineTo(corners.topLeft.x, corners.topLeft.y);
    ctx.stroke();
    ctx.closePath();
  }

  isInBound(x, y){
    return this.isBetween(x, this.x, this.x + this.width)
    && this.isBetween(y, this.y, this.bottomLeft);
  }

  isInBoundRotation(x,y){
    let corners = this.getRotatedCorners();
    return this.isBetween(x, corners.topLeft.x, corners.bottomRight.x)
    && this.isBetween(y, corners.bottomLeft.y, corners.topRight.y);
  }

  getRotatedCorners(){
    let ruler = {x: this.x, y: this.y};
    let sin = Math.sin(this.textContextRotation);
    let cos = Math.cos(this.textContextRotation);
    let h = this.height;
    let w = this.width;
    let corners ={
      topLeft: ruler ,  
      topRight: {x: ruler.x + w*cos, y: ruler.y + w*sin},
      bottomLeft: { x: ruler.x - h*sin, y: ruler.y + h*cos},
      bottomRight: {x: ruler.x + w*cos - h*sin, y: ruler.y + w*sin + h*cos}
    }
    return corners;
  }
  
  isBetween(value, bound1, bound2) {
    const min = Math.min(bound1, bound2);
    const max = Math.max(bound1, bound2);
    return value >= min && value <= max;
  }

  updateLocation(x, y){
    this.isDetach = true;
    this.x = x;
    this.y = y;
  }
}